import axios from "axios";

export default {
    fetchMedal(id) {
        return axios.get('medals/' + id)
            .then(response => {
                return response.data
            })
    },

    fetchMedals() {
        return axios.get('medals')
            .then(response => {
                return response.data
            })
    },

}
